import { defineComponent, ref } from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import * as bootstrap from "bootstrap";
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);
import * as duration from 'dayjs/plugin/duration';
dayjs.extend(duration);
import * as relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);
import CompteareboursComponent from '../../Views/Shared/comptearebours.vue';
import EditpersorowsComponent from '../DetecterConfig/editpersorows.vue';
import { QuillEditor } from '@vueup/vue-quill';

import { ConfMenuElem, zone, DCMenuElem, DCMenuConfig, ForumShareRequest, DCBreadcrumb, DCConfigurateurViewModel, DCConfigurateurModule, PaginationConfEventPage, typemeta, MCMetaData, RenderElemType, ElemConfig, PaginationElemConfig, ImgElemConfig, TextElemConfig, TabElemConfig, GroupeElemConfig, PersoElemConfig, BaliseElemConfig, PartitionConfig, PartitionElemConfig, DCConfigurationViewApiModel, ConfigViewApiModel, ConfigViewApiRequest, PersoConfigView, PersoConfigRequest, ShareConfApiViewModel, ShareConfigRequest, ShareConfig_Type, DCConfigurateurModules } from "./../../Scripts/js/detecterconfig";
import { VueSignalR } from './../../Scripts/js/signalrmonitoring.service';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { createPinia } from 'pinia';

let gidpageselect: number = 0;
let gidsubpageselect: number = 0;
let gdepth: number = 0;
let gurlresume: string = "";
let gurlresume2: string = "";
let gidconfig: string = "";
let gpage: number = 0;
let gmachine: number = 0;
let gdateexpiration: number = 0;

let gapp: Vue.App<DCApp>;
const mixin = defineComponent({
    components: { CompteareboursComponent, EditpersorowsComponent, QuillEditor },
    data() {
        return {
            viewmodel: null as ConfigViewApiModel | null,
            viewpartagemodel: null as ShareConfApiViewModel | null,
            configtoshare: [] as number[],
            typepartage:0,
            dateconfigexpiration: null as Date | null,
            modulespersoresume: null as DCConfigurateurModules | null,
            opentiroirresume: "",
            featuresid:[] as string[],
            userpublish: 0,
            levelsecu: 1,
            shareemailuser:"",
            linkshare: "",
            urlfacebook: "",
            urltwitter: "",
            socialemail:"",
            resumeurl2:"",
            m_modal: null as bootstrap.Modal | null,
            aideforumtitre_text: "",
            aideforumcontenu_text: "",
            idpageselect: 0,
            idsubpageselect: 0,
            page: 1,
            machine: 0,
            resumeurl:"",
            idconfiguser:"",
            m_catactivename: "resume",
            m_titlepagecomplet:"",
            m_subtitle: "",
            depth: 0,
            breadcrumb: null as DCBreadcrumb|null,
            loading: false,
            dc_descpilotesreferer: "",
            errmsgprivate: "",
            errmsgpublic: "",
            hasshareprivate: false
        };
    },
    created() {
        this.depth = gdepth;
        this.machine = gmachine;
        this.idpageselect = gidpageselect;
        this.idsubpageselect = gidsubpageselect;
        this.idconfiguser = gidconfig;
        this.resumeurl = gurlresume;
        this.resumeurl2 = gurlresume2;
        if (gdateexpiration === 0)
            this.dateconfigexpiration = null;
        else
            this.dateconfigexpiration = dayjs(gdateexpiration*1000).local().toDate();
        this.page = gpage;
    },



    mounted() {
       
    },
    watch: {
        opentiroirresume(value) {
            if (value != "")
                this.$nextTick(function () {
                    this.ScrollPerso();
                });
        }
    },
    methods: {
        DCImprimerConfig() {
            window.print();
        },
        CopyClipboard(text: string) {
            navigator.clipboard.writeText(text);
        },
        DCPartagerConfig() {
            this.LoadShareModal();
            const elt = document.getElementById('dc_shareconfigdialog');
            if (elt !== null) {
                this.m_modal = new bootstrap.Modal(elt, {});
                this.m_modal.show();
            }
        },
        ScrollPerso() {
            let elt = document.getElementById('persoblocresumeedit');
            if (elt != null)
                window.scrollTo(0, elt.offsetTop-90);
        },
        DCShareConfig(all:boolean,descreu:string,lan:string,theme:string) {
            const publish: ShareConfigRequest = new ShareConfigRequest();
            publish.configstoshare = this.configtoshare;
            publish.levelsecu = this.levelsecu;
            publish.lan = lan;
            publish.theme = theme;
            if (all)
                publish.sharetypepublish = ShareConfig_Type.ALL;
            else
                publish.sharetypepublish = ShareConfig_Type.USER;
            publish.usertoshare = this.userpublish;
            this.ShareConfig(publish, descreu);
        },
        FindUser(reumsg: string, failmsg: string) {
            let url: string = "/api/v1/Login/FindUser?usernameoremail=" + this.shareemailuser;
            let self = this;

            axios.get<number>(url).then(function (response: AxiosResponse<number>) {
                if (response !== null) {
                    if (response.data !== null) {
                        self.hasshareprivate = false;
                        self.userpublish = response.data;
                        if (self.userpublish == 0)
                            self.errmsgprivate = failmsg;
                        else
                            self.errmsgprivate = reumsg+" <b>"+self.shareemailuser+"</b>?";
                    }
                    else
                        self.errmsgprivate = failmsg;
                }
                else
                    self.errmsgprivate = failmsg;
            });
        },
        LoadShareModal() {
            this.linkshare = "";
              let url: string = "/api/v1.0/ShareConfig/LoadShareModal";
            let self = this;
              axios.get<ShareConfApiViewModel>(url).then(function (response: AxiosResponse<ShareConfApiViewModel>) {
                if (response.data!==null) {
                    self.viewpartagemodel = response.data;
                    if (self.viewpartagemodel != null && self.viewpartagemodel.m_configblob.length == 1)
                        self.configtoshare.push(self.viewpartagemodel.m_configblob[0].idnum);
                }
            });
        },
        ShareConfig(publish: ShareConfigRequest, descreu: string) {
            let url: string = "/api/v1.0/ShareConfig/ShareConfig";
            let self = this;
            axios.post<string>(url, publish).then(function (response: AxiosResponse<string>) {

                if (publish.sharetypepublish === ShareConfig_Type.USER) {
                    self.errmsgprivate = descreu;
                    self.hasshareprivate = true;
                }
                else {
                    if (response.data != "") {
                        self.errmsgpublic = descreu;
                        self.linkshare = self.resumeurl2.replace("%idconfig%", response.data);
                        self.InitButSocial();
                        setTimeout(() => {
                            let elt = document.querySelector('.linkdirect');
                            if (elt !== null) {
                                var popover = new bootstrap.Popover(elt, {
                                    container: 'body'
                                });
                            }
                        }, 100);
                    }
                }
            });
        },
        InitButSocial() {
            const titleconfig="Configuration DriversCloud";
            if (this.linkshare !== "")
                this.urlfacebook = "https://www.facebook.com/sharer/sharer.php?u=" + this.linkshare + "&t=" + titleconfig;
            if (this.linkshare !== "")
                this.urltwitter = "https://twitter.com/intent/tweet?text=" + this.linkshare;
            if (this.linkshare !== "")
                this.socialemail = "mailto:?subject=" + titleconfig + "&body=" + this.linkshare;
        },
        DCAideForum() {
            const elt = document.getElementById('dc_aideforumdialog');
            if (elt !== null) {
                this.m_modal = new bootstrap.Modal(elt, {});
                this.m_modal.show();
            }
        },
        AideForumPoster() {
            const request: ForumShareRequest = new ForumShareRequest();
            request.titre = this.aideforumtitre_text;
            request.contenu = this.aideforumcontenu_text;
            request.idconfig = this.idconfiguser;
            this.ShareOnForum(request);
            if (this.m_modal !== null) {
                this.m_modal.hide();
            }
        },
        ShareOnForum(request: ForumShareRequest) {
            let url: string = "/api/v1.0/ShareConfig/ShareOnForum";
            let self = this;
            axios.post<string>(url,request).then(function (response: AxiosResponse<string>) {
                if (response.data!=="") {
                    location.href = response.data;
                }
            });
        },
        DCDeleteConfig(machine: number, descconfirm: string) {
            let choice: boolean = confirm(descconfirm);
            if (choice == false)
                return;
            let url: string = "/api/v1.0/DetecterConfig/DeleteConfMachineCurrent?machine=" + machine;
            let self = this;
            axios.delete<boolean>(url).then(function (response: AxiosResponse<boolean>) {
                if (response.data) {
                    location.href = self.resumeurl;
                }
            });
        },
        DCDeleteConfigMon(idconfiguser: string, descconfirm: string) {
            let choice: boolean = confirm(descconfirm);
            if (choice == false)
                return;
            let url: string = "/api/v2.0/RealTimeService/DeleteConfigMon?idconfiguserstr="+idconfiguser;
            let self = this;
            axios.delete<boolean>(url).then(function (response: AxiosResponse<boolean>) {
                if (response.data) {
                    location.href = self.resumeurl;
                }
            });
        },
        DCDeleteConfigCurrent(descconfirm:string) {
            this.DCDeleteConfig(this.machine, descconfirm);
        },
        IsVideCurrentPage(): boolean {
            let ret= ((this.viewmodel != null && this.viewmodel.m_configuration != null) && (this.viewmodel.m_configuration.m_configtaches.length < 1 || this.viewmodel.m_configuration.m_configtaches[0].type != RenderElemType.page || (this.viewmodel.m_configuration.m_configtaches[0].page!=null&&this.viewmodel.m_configuration.m_configtaches[0].page.matos.length == 0)));
            return ret;
        },
        PlierCategorie(lang: string,i: number, idconfiguser: string, pagefirst: number, newurl: string) {
         //   alert(i + " " + this.idpageselect);
            this.DetecterConfig(lang,i, 0, idconfiguser, pagefirst, false,"",newurl);
        },
        GoToUrl(menus: DCMenuElem) {
            if (menus.submenu===null)
                return;
            if (menus.submenu[0].submenu === null)
                location.href = menus.submenu[0].url;
            else {
                for (let menuaux of menus.submenu[0].submenu) {
                    if (menuaux.submenu === null) {
                        location.href = menuaux.url;
                        return;
                    }
                    else {
                        for (let menuaux2 of menuaux.submenu) {
                            location.href = menuaux2.url;
                            return;
                        }
                    }
                }
            }
        },
        GetModulePersoResume(idmodule: string, lang:string) {
            let url: string = "/api/v1.0/dcconfigurateur/GetModule?idconfig=" + this.idconfiguser + "&idmodule=" + idmodule+"&lang="+lang;
            let self = this;
            axios.get<DCConfigurateurViewModel>(url).then(function (response: AxiosResponse<DCConfigurateurViewModel>) {
                if (response !== null)
                    if (response.data !== null) {
                        self.modulespersoresume = response.data.m_moduleselect;
                        self.featuresid = [];
                        if (self.modulespersoresume != null) {
                            for (let feature of self.modulespersoresume.features) {
                                if (feature.ischecked)
                                    self.featuresid.push(feature.id);
                            }
                            }
                        
                    }
            });
        },
        EditModulePersoResume(module: DCConfigurateurModule) {
            let url: string = "/api/v1.0/dcconfigurateur/EditModule";
            let self = this;
            this.loading = true;
            axios.post<boolean>(url,module).then(function (response: AxiosResponse<boolean>) {
                if (response !== null)
                    if (response.data) {
                        location.reload();
                    }
                    else
                        self.loading = false;
            });
        },
        OpenTiroirPersoResume(module: string,lang:string) {
            this.opentiroirresume = module;
            this.GetModulePersoResume(module, lang);
            this.ReloadTooltips();
        },
        FermerTiroir() {
            this.opentiroirresume = "";
            this.ReloadTooltips();
        },
        SavePersoFeatures(lang:string) {
            //this.opentiroirresume = "";
            const request: DCConfigurateurModule = new DCConfigurateurModule();
            if (this.modulespersoresume !== null) {
                request.id = this.modulespersoresume.id;
                request.featuresid = this.featuresid;
                request.lang = lang;
                this.EditModulePersoResume(request);
            }
        },
        DCMoreInfosParent(lang: string,event: PaginationConfEventPage) {
            this.DetecterConfig(lang,event.i, event.j, event.idconfiguser, event.page, true, "", "");
        },
        DCMoreInfos(lang: string,i: number, j: number, idconfiguser: string, page: number) {
            this.DetecterConfig(lang,i, j, idconfiguser, page, true, "", "");
        },
        isTouchDevice() {
            return 'ontouchstart' in window || (window as any)['DocumentTouch'] && document instanceof (window as any)['DocumentTouch'];
        },
        ReloadTooltips() {
            $("[data-bs-toggle='tooltip']").tooltip('hide');
            this.$nextTick(function () {
                if (!this.isTouchDevice()) {
                    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                        return new bootstrap.Tooltip(tooltipTriggerEl)
                    });
                }
                else
                    $('[data-bs-toggle="tooltip"]').removeAttr("title");
            });
        },
        DetecterConfig(lang: string,i: number, j: number, idconfiguser: string, page: number, details: boolean, search: string, newurl: string) {
            let url: string = "/api/v1.0/DetecterConfig/DetecterConfig";
            let self = this;
            let request: ConfigViewApiRequest = new ConfigViewApiRequest();
            request.idconfiguser = idconfiguser;
            request.page = page;
            request.details = details;
            request.search = search;
            request.lang = lang;
            this.loading = true;
            axios.post<ConfigViewApiModel>(url, request).then(function (response: AxiosResponse<ConfigViewApiModel>) {
                if (response !== null)
                    if (response.data !== null) {
                        self.viewmodel = response.data;
                        if (self.viewmodel.m_configuration !== null) {
                            self.idpageselect = self.viewmodel.m_configuration.idpageselect;
                            self.idsubpageselect = self.viewmodel.m_configuration.idsubpageselect;
                            self.idconfiguser = self.viewmodel.m_idconfiguserurl;
                            self.page = self.viewmodel.page;
                            self.m_catactivename = self.viewmodel.m_configuration.m_catactivename;
                            self.m_titlepagecomplet = self.viewmodel.m_configuration.m_titlepagecomplet;
                            self.m_subtitle = self.viewmodel.m_configuration.m_subtitle;
                            self.depth = self.viewmodel.m_configuration.depth;
                            self.breadcrumb = self.viewmodel.m_breadcrumb;
                            if (self.viewmodel.m_dateconfigexpiration === null)
                                self.dateconfigexpiration = null;
                            else
                                self.dateconfigexpiration = dayjs(self.viewmodel.m_dateconfigexpiration).local().toDate();
                            if (newurl != "") 
                                window.history.pushState(null, "", newurl);
                            self.ReloadTooltips();
                            setTimeout(() => {
                                let elem = $("#dcmodule_" + i + "_" + j).offset();
                                if (elem != null)
                                    $('html, body').animate({ scrollTop: elem.top - 90 }, 100);
                            }, 100);
                            self.loading = false;
                        }
                    }
            });
            return false;
        }
    }
});


export class DetecterConfigComponent {
    public Init(dateexpiration:number,depth: number, idpageselect: number, idsubpageselect: number,idconfig: string,page: number,machine:number,urlresume:string,urlresume2: string) {
        gdepth = depth;
        gdateexpiration = dateexpiration;
        gidpageselect = idpageselect;
        gidsubpageselect = idsubpageselect;
        gidconfig = idconfig;
        gmachine = machine;
        gurlresume = urlresume;
        gurlresume2 = urlresume2;
        gpage = page;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        gapp = app;
        const connection = new HubConnectionBuilder().withUrl('/SignalRDriversCloud').build();
        app.use(VueSignalR, connection);
        app.mount('#rootpage');
    }
}
(<any>(window)).DetecterConfigComponent = function () { return new DetecterConfigComponent(); };